"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldOption = /** @class */ (function () {
    function FieldOption(label, value) {
        this.label = label;
        this.value = value;
    }
    return FieldOption;
}());
exports.default = FieldOption;
